import { render, staticRenderFns } from "./projectBackground.vue?vue&type=template&id=1a348418&scoped=true&"
import script from "./projectBackground.vue?vue&type=script&lang=js&"
export * from "./projectBackground.vue?vue&type=script&lang=js&"
import style0 from "./projectBackground.vue?vue&type=style&index=0&id=1a348418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a348418",
  null
  
)

export default component.exports